import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, typography, spacing }) => ({
  root: {
    '& $topic': {
      borderRadius: 6
    },
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: spacing(1)
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: spacing(2.6),
    '& .MuiIconButton-root': {
      background: palette.primary.main,
      color: 'white',
      padding: spacing(0.5)
    }
  },
  topics: {
    padding: spacing(3, 0),
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  topic: {
    ...typography.body.s,
    textTransform: 'capitalize',
    background: palette.grey.shade[5],
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: palette.grey.shade[10],
    boxSizing: 'border-box',
    borderRadius: 6,
    color: palette.grey.shade[80],
    fontWeight: typography.fontWeightRegular,
    '&.MuiChip-colorPrimary': {
      background: palette.primary.main,
      color: 'white'
    },
    '& b': {
      fontWeight: typography.fontWeightBold
    }
  },
  unSelectedIcon: {
    display: 'block'
  },
  selectedIcon: {
    display: 'none'
  },
  load: {
    marginTop: spacing(2)
  },
  topicChip: {
    margin: spacing(0.5)
  }
}))
